import * as React from 'react';
import { getTrackedLink } from '../../utils/sourceTracking';

// @ts-ignore
import logo from '../Header/belle-tire-logo.svg';

const Footer: React.FC = () => {
	return (
		<footer className={'font-rubik'}>
			<div className={'bg-white px-3'}>
				<div
					className={
						'container mx-auto flex flex-row justify-between py-10 max-sm:flex-col-reverse max-sm:text-center'
					}
				>
					<div className={'flex flex-col text-2xl'}>
						<b>CONTACT US</b>
						<p className={'text-xl'}>
							<a
								className={'hover:text-bt-red'}
								href={
									'https://www.google.com/maps/place/25800+Northwestern+Hwy+Floor+10,+Southfield,+MI+48075,+USA/@42.479159,-83.2500932,612m/data=!3m2!1e3!4b1!4m5!3m4!1s0x8824c82885ad8bfb:0x7da7a60164501188!8m2!3d42.4791551!4d-83.2475183?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoASAFQAw%3D%3D'
								}
								target={'_blank'}
							>
								25800 Northwestern Highway, Floor 10 <br />
								Southfield, Michigan 48075
							</a>
							<br />
							<a
								className={'hover:text-bt-red'}
								href={'tel:18884623553'}
							>
								888-GO-BELLE (888-462-3553)
							</a>
						</p>
					</div>
					<div className={'max-sm:py-5'}>
						<a href={getTrackedLink('/')}>
							<img
								src={logo}
								width={180}
								className={'flex max-sm:mx-auto'}
							/>
						</a>
					</div>
				</div>
			</div>
			<div className={'bg-bt-blue py-5 px-3'}>
				<div
					className={
						'container mx-auto text-center text-xl text-white'
					}
				>
					<span>
						Copyright ©{new Date().getFullYear()} All Rights
						Reserved.
					</span>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
